export const responsiveClassNames = {
  mobile: 'mobile',
  tabletSmall: 'tablet-small',
  tabletBig: 'tablet-big',
  desktop: 'desktop',
}
